export default __webpack_public_path__ + "img/dapJLUND.0a5c981d.svg";